import { h as i } from "vue";
const v = (e, s) => {
  const l = "http://www.w3.org/2000/svg", t = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path fill-rule="evenodd" d="M15.2 8a.8.8 0 01-.8-.8V2.4a.8.8 0 011.6 0v4.8a.8.8 0 01-.8.8zm-9.6 9.6H.8a.8.8 0 010-1.6h4.8a.8.8 0 010 1.6zm24 0h-4.8a.8.8 0 010-1.6h4.8a.8.8 0 010 1.6zM15.2 32a.8.8 0 01-.8-.8v-4.8a.8.8 0 011.6 0v4.8a.8.8 0 01-.8.8zm0-20.789a5.569 5.569 0 00-3.96 1.639A5.544 5.544 0 009.6 16.8c0 1.493.582 2.894 1.64 3.95a5.562 5.562 0 003.96 1.639 5.569 5.569 0 003.96-1.639 5.544 5.544 0 001.64-3.95 5.547 5.547 0 00-1.64-3.95 5.562 5.562 0 00-3.96-1.639zm0-1.6c3.976 0 7.2 3.22 7.2 7.189 0 3.971-3.224 7.189-7.2 7.189S8 20.77 8 16.8s3.224-7.189 7.2-7.189zm-6.389.8a.804.804 0 01-.566-.233L4.85 6.784a.8.8 0 011.131-1.131l3.394 3.393a.8.8 0 01-.566 1.365h.001zM5.418 28.182a.8.8 0 01-.566-1.365l3.393-3.393a.8.8 0 011.131 1.131L5.982 27.95a.797.797 0 01-.566.233h.002zm16.17-17.77a.8.8 0 01-.566-1.365l3.394-3.394a.8.8 0 011.131 1.131l-3.393 3.394a.797.797 0 01-.567.233h.002zm3.394 17.77a.804.804 0 01-.566-.233l-3.394-3.394a.8.8 0 011.132-1.131l3.393 3.394a.8.8 0 01-.566 1.364h.001z"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(l, "title");
    a.textContent = e.title, t.appendChild(a);
  }
  const r = Array.from((t == null ? void 0 : t.attributes) ?? []).reduce((a, n) => ({
    ...a,
    [n.name]: n.value
  }));
  return i(
    "svg",
    {
      ...r,
      ...s.attrs,
      role: "img",
      innerHTML: t.innerHTML
    }
  );
};
export {
  v as default
};
//# sourceMappingURL=SunIcon.BBk_bORh.js.map
